/* =====================================================================
 * Régler Watches – 2D configurator (kast + band)
 * ---------------------------------------------------------------------
 * - Data komt uit sections/regler-configurator.liquid (JSON in de sectie)
 * - Status in de URL: ?family=round&case=<handle>&strap=<handle>
 * - Voegt kast, band (en optioneel giftbag) toe als losse regels met
 *   dezelfde line item property _rw_set, zodat gifts en orders per set kloppen
 * - Werkt samen met assets/custom.js (window.RWGifts)
 * ===================================================================== */
(function () {
  'use strict';

  var money = function (cents, format) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (format || '€{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  };

  // Pre-order teksten (de sectie levert ze mee zodra ze daar staan; anders deze)
  var LANG = (document.documentElement.lang || 'en').slice(0, 2);
  var PRE = {
    nl: { tag: 'Pre-order', note: 'Bevat een onderdeel op pre-order. Wordt verzonden zodra de nieuwe voorraad binnen is.' },
    de: { tag: 'Vorbestellung', note: 'Enthält ein vorbestelltes Teil. Versand, sobald der neue Bestand eintrifft.' },
    fr: { tag: 'Précommande', note: 'Contient une pièce en précommande. Expédié dès réception du nouveau stock.' },
    en: { tag: 'Pre-order', note: 'Includes a pre-order component. Ships as soon as new stock arrives.' }
  }[['nl','de','fr'].indexOf(LANG) === -1 ? 'en' : LANG];

  // Voorraadstatus per onderdeel ophalen: verkoopbaar zonder fysieke voorraad = pre-order
  var stockCache = {};
  async function isPreorder(handle) {
    if (handle in stockCache) return stockCache[handle];
    stockCache[handle] = false;
    try {
      var r = await fetch('/products/' + handle + '.js', { cache: 'no-store' });
      if (r.ok) {
        var p = await r.json(), v = p.variants && p.variants[0];
        if (v && v.available && v.inventory_management && v.inventory_policy === 'continue' && v.inventory_quantity <= 0) stockCache[handle] = true;
      }
    } catch (e) {}
    return stockCache[handle];
  }

  // Analytics: events voor een Shopify Custom Pixel (analytics.subscribe('regler_configurator', ...))
  function track(action, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('regler_configurator', Object.assign({ action: action }, data || {}));
      }
    } catch (e) {}
  }

  class RWConfigurator extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      this.cfg = this.data.settings;
      this.items = this.data.items.filter(function (i) { return i.enabled; });
      this.cases = this.items.filter(function (i) { return i.type === 'case'; }).sort(function (a, b) { return a.sort - b.sort; });
      this.straps = this.items.filter(function (i) { return i.type === 'strap'; }).sort(function (a, b) { return a.sort - b.sort; });

      this.els = {
        familyBtns: this.querySelectorAll('[data-rwc-family]'),
        caseGrid: this.querySelector('[data-rwc-grid="case"]'),
        strapGrid: this.querySelector('[data-rwc-grid="strap"]'),
        strapFilter: this.querySelectorAll('[data-rwc-strap-type]'),
        seriesFilter: this.querySelectorAll('[data-rwc-case-series]'),
        seriesRow: this.querySelector('[data-rwc-series-filter]'),
        stage: this.querySelector('[data-rwc-stage]'),
        layerCase: this.querySelector('[data-rwc-layer="case"]'),
        layerStrap: this.querySelector('[data-rwc-layer="strap"]'),
        inset: this.querySelector('[data-rwc-inset]'),
        insetImg: this.querySelector('[data-rwc-inset] img'),
        previewNote: this.querySelector('[data-rwc-preview-note]'),
        sumCase: this.querySelector('[data-rwc-sum="case"]'),
        sumStrap: this.querySelector('[data-rwc-sum="strap"]'),
        priceParts: this.querySelector('[data-rwc-price-parts]'),
        priceSet: this.querySelector('[data-rwc-price-set]'),
        priceNote: this.querySelector('[data-rwc-price-note]'),
        preNote: this.querySelector('[data-rwc-preorder-note]'),
        gift: this.querySelector('[data-rwc-gift]'),
        addBtn: this.querySelector('[data-rwc-add]'),
        share: this.querySelector('[data-rwc-share]'),
        error: this.querySelector('[data-rwc-error]'),
        steps: this.querySelectorAll('[data-rwc-step]'),
        bar: this.querySelector('[data-rwc-mobilebar]'),
        barImg: this.querySelector('[data-rwc-mobilebar-img]'),
        barImg2: this.querySelector('[data-rwc-mobilebar-img2]'),
        barLabel: this.querySelector('[data-rwc-mobilebar-label]'),
        barPrice: this.querySelector('[data-rwc-mobilebar-price]'),
        barAdd: this.querySelector('[data-rwc-mobilebar-add]'),
        barJump: this.querySelectorAll('[data-rwc-mobilebar-jump]'),
        summary: this.querySelector('[data-rwc-step="summary"]')
      };

      this.state = { family: this.cfg.defaultFamily || 'round', caseId: null, strapId: null, strapType: 'all', caseSeries: this.cfg.defaultSeries || 'infinite', gift: false };
      this.readUrl();
      this.applyPreselect();
      this.bind();
      this.renderAll();
      track('viewed', { family: this.state.family, preselected: !!(this.state.caseId || this.state.strapId) });
    }

    /* ---------- state helpers ---------- */
    byHandle(list, handle) { return list.find(function (i) { return i.handle === handle; }) || null; }
    current() {
      return {
        c: this.cases.find(function (i) { return i.handle === this.state.caseId; }, this) || null,
        s: this.straps.find(function (i) { return i.handle === this.state.strapId; }, this) || null
      };
    }
    readUrl() {
      var p = new URLSearchParams(location.search);
      if (p.get('family') && (p.get('family') === 'round' || p.get('family') === 'elegance')) this.state.family = p.get('family');
      var c = this.byHandle(this.cases, p.get('case'));
      var s = this.byHandle(this.straps, p.get('strap'));
      if (c) { this.state.family = c.family; this.state.caseId = c.handle; if (c.series) this.state.caseSeries = c.series; }
      if (s && s.family === this.state.family) this.state.strapId = s.handle;
    }
    applyPreselect() {
      // Op een productpagina: het huidige onderdeel alvast selecteren
      var pre = this.cfg.preselect;
      if (!pre || this.state.caseId || this.state.strapId) return;
      var c = this.byHandle(this.cases, pre), s = this.byHandle(this.straps, pre);
      if (c) { this.state.family = c.family; this.state.caseId = c.handle; if (c.series) this.state.caseSeries = c.series; }
      if (s) { this.state.family = s.family; this.state.strapId = s.handle; }
    }
    writeUrl() {
      if (!this.cfg.syncUrl) return;
      var p = new URLSearchParams(location.search);
      p.set('family', this.state.family);
      if (this.state.caseId) p.set('case', this.state.caseId); else p.delete('case');
      if (this.state.strapId) p.set('strap', this.state.strapId); else p.delete('strap');
      history.replaceState(null, '', location.pathname + '?' + p.toString());
    }

    /* ---------- events ---------- */
    bind() {
      var self = this;
      this.els.familyBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          if (self.state.family === b.dataset.rwcFamily) return;
          self.state.family = b.dataset.rwcFamily;
          self.state.caseId = null; self.state.strapId = null; self.state.caseSeries = self.cfg.defaultSeries || 'infinite';
          self.renderAll();
        });
      });
      this.els.strapFilter.forEach(function (b) {
        b.addEventListener('click', function () { self.state.strapType = b.dataset.rwcStrapType; self.renderGrid('strap'); });
      });
      this.els.seriesFilter.forEach(function (b) {
        b.addEventListener('click', function () { self.state.caseSeries = b.dataset.rwcCaseSeries; self.renderGrid('case'); });
      });
      this.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-rwc-option]');
        if (!opt || opt.disabled) return;
        var type = opt.dataset.rwcType, handle = opt.dataset.rwcOption;
        if (type === 'case') self.state.caseId = (self.state.caseId === handle) ? null : handle;
        if (type === 'strap') self.state.strapId = (self.state.strapId === handle) ? null : handle;
        var picked = type === 'case' ? self.state.caseId : self.state.strapId;
        if (picked) track(type + '_selected', { handle: picked, family: self.state.family });
        // na een kastkeuze de bijpassende bandkleur vooraan zetten
        if (type === 'case') self.renderGrid('strap');
        self.renderGrid(type); self.renderPreview(); self.renderSummary(); self.writeUrl();
        if (type === 'case' && self.state.caseId && !self.state.strapId) self.scrollToStep('strap');
      });
      if (this.els.gift) this.els.gift.addEventListener('change', function () { self.state.gift = self.els.gift.checked; self.renderSummary(); });
      if (this.els.addBtn) this.els.addBtn.addEventListener('click', function () { self.addToCart(); });
      if (this.els.share) this.els.share.addEventListener('click', function () { self.share(); });
      if (this.els.barAdd) this.els.barAdd.addEventListener('click', function () { self.addToCart(); });
      this.els.barJump.forEach(function (b) {
        b.addEventListener('click', function () {
          var stage = self.els.stage; if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      // Balk verbergen zodra het overzicht (met de echte knop) in beeld is
      this.summaryVisible = false;
      if (this.els.summary && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          self.summaryVisible = entries[0].isIntersecting; self.renderBar();
        }, { threshold: 0.15 });
        io.observe(this.els.summary);
      }
      // Balk alleen tonen zolang de configurator zelf in beeld is
      this.inView = true;
      if ('IntersectionObserver' in window) {
        var ioSelf = new IntersectionObserver(function (entries) {
          self.inView = entries[0].isIntersecting; self.renderBar();
        }, { threshold: 0, rootMargin: '-80px 0px -80px 0px' });
        ioSelf.observe(this);
      }
    }
    scrollToStep(name) {
      var el = this.querySelector('[data-rwc-step="' + name + '"]');
      if (el && window.matchMedia('(max-width: 767px)').matches) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ---------- rendering ---------- */
    renderAll() {
      var self = this;
      this.els.familyBtns.forEach(function (b) {
        var on = b.dataset.rwcFamily === self.state.family;
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
      });
      this.renderGrid('case'); this.renderGrid('strap'); this.renderPreview(); this.renderSummary(); this.writeUrl();
    }
    renderGrid(type) {
      var self = this, grid = type === 'case' ? this.els.caseGrid : this.els.strapGrid;
      if (!grid) return;
      var list = (type === 'case' ? this.cases : this.straps).filter(function (i) { return i.family === self.state.family; });
      if (type === 'strap' && this.state.strapType !== 'all') list = list.filter(function (i) { return i.strapType === self.state.strapType; });
      if (type === 'strap') {
        var curCase = this.current().c;
        if (curCase && curCase.swatch) {
          var sw = String(curCase.swatch).toLowerCase();
          list = list.slice().sort(function (a, b) {
            var am = String(a.swatch || '').toLowerCase() === sw ? 0 : 1;
            var bm = String(b.swatch || '').toLowerCase() === sw ? 0 : 1;
            return am - bm || a.sort - b.sort;
          });
        }
      }
      this.els.strapFilter.forEach(function (b) { b.classList.toggle('is-active', b.dataset.rwcStrapType === self.state.strapType); });
      if (type === 'case') {
        // Serie-filter (Infinité / Liberté) alleen zinvol binnen de ronde familie
        var roundFamily = this.state.family === 'round';
        if (this.els.seriesRow) this.els.seriesRow.hidden = !roundFamily;
        if (roundFamily) list = list.filter(function (i) { return i.series === self.state.caseSeries; });
        this.els.seriesFilter.forEach(function (b) { b.classList.toggle('is-active', b.dataset.rwcCaseSeries === self.state.caseSeries); });
      }

      var selected = type === 'case' ? this.state.caseId : this.state.strapId;
      grid.innerHTML = list.map(function (i) {
        var cls = 'rwc-option' + (i.handle === selected ? ' is-selected' : '') + (i.available ? '' : ' is-unavailable');
        return '<button type="button" class="' + cls + '" data-rwc-option="' + i.handle + '" data-rwc-type="' + type + '"' + (i.available ? '' : ' disabled') + ' aria-pressed="' + (i.handle === selected) + '">' +
          '<span class="rwc-option__img"><img src="' + i.thumb + '" alt="" loading="lazy" width="300" height="300"></span>' +
          '<span class="rwc-option__check" aria-hidden="true"><svg viewBox="0 0 16 16" width="12" height="12"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          (i.preorder ? '<span class="rwc-option__badge rwc-option__badge--pre">' + (self.cfg.t.preorder || PRE.tag) + '</span>' : (i.badge ? '<span class="rwc-option__badge">' + i.badge + '</span>' : '')) +
          (i.available ? '' : '<span class="rwc-option__soldout">' + self.cfg.t.soldOut + '</span>') +
          '<span class="rwc-option__label">' + i.label + '</span>' +
          '<span class="rwc-option__meta">' +
            (i.swatch ? '<span class="rwc-swatch" style="background:' + i.swatch + '"></span>' : '') +
            (i.dial ? '<span class="rwc-swatch rwc-swatch--dial" style="background:' + i.dial + '"></span>' : '') +
            '<span class="rwc-option__price">' + money(i.price, self.cfg.moneyFormat) + '</span>' +
          '</span></button>';
      }).join('') || '<p class="rwc-empty">' + this.cfg.t.none + '</p>';
    }
    renderPreview() {
      var cur = this.current(), stage = this.els.stage;
      if (!stage) return;
      var layered = cur.c && cur.s && cur.c.hasLayer && cur.s.hasLayer;
      stage.classList.toggle('rwc-stage--layered', !!layered);
      stage.classList.toggle('rwc-stage--empty', !cur.c && !cur.s);

      // Kast bovenop, band eronder
      this.setImg(this.els.layerCase, cur.c ? (layered ? cur.c.layer : cur.c.image) : '');
      this.setImg(this.els.layerStrap, cur.s && layered ? cur.s.layer : '');

      // Fallback zonder laagafbeeldingen: band als inzet naast de kast
      var showInset = cur.s && !layered;
      if (this.els.inset) this.els.inset.hidden = !showInset;
      if (showInset) this.setImg(this.els.insetImg, cur.s.image);
      if (!cur.c && cur.s && !layered) this.setImg(this.els.layerCase, cur.s.image), this.els.inset.hidden = true;
      if (this.els.previewNote) this.els.previewNote.hidden = !(cur.c && cur.s && !layered);
    }
    setImg(el, src) { if (!el) return; if (src) { if (el.getAttribute('src') !== src) el.setAttribute('src', src); el.hidden = false; } else { el.hidden = true; el.removeAttribute('src'); } }
    renderSummary() {
      var cur = this.current(), t = this.cfg.t, f = this.cfg.moneyFormat;
      if (this.els.sumCase) this.els.sumCase.textContent = cur.c ? cur.c.label : t.chooseCase;
      if (this.els.sumStrap) this.els.sumStrap.textContent = cur.s ? cur.s.label : t.chooseStrap;
      var parts = (cur.c ? cur.c.price : 0) + (cur.s ? cur.s.price : 0);
      var both = cur.c && cur.s;
      var discount = both ? this.cfg.setDiscount : 0;
      var total = parts - discount + (this.state.gift && this.cfg.gift ? this.cfg.gift.price : 0);
      if (this.els.priceParts) { this.els.priceParts.textContent = money(parts, f); this.els.priceParts.hidden = !both; }
      if (this.els.priceSet) this.els.priceSet.textContent = money(total, f);
      if (this.els.priceNote) this.els.priceNote.hidden = !both;
      // pre-order melding zodra een van de gekozen onderdelen nog moet binnenkomen
      var self2 = this;
      if (this.els.preNote) {
        var chosen = [cur.c, cur.s].filter(Boolean);
        Promise.all(chosen.map(function (x) { return isPreorder(x.handle); })).then(function (res) {
          var any = res.some(Boolean);
          res.forEach(function (v, i) { chosen[i].preorder = v; });
          self2.els.preNote.hidden = !any;
          if (any) self2.els.preNote.textContent = (t.preorderNoteNone || PRE.note);
          if (any) { self2.renderGrid('case'); self2.renderGrid('strap'); }
        });
      }
      if (this.els.addBtn) {
        this.els.addBtn.disabled = !(cur.c || cur.s);
        this.els.addBtn.textContent = both ? t.addSet : (cur.c || cur.s ? t.addSingle : t.addSet);
      }
      this.els.steps.forEach(function (s) {
        var name = s.dataset.rwcStep;
        s.classList.toggle('is-done', (name === 'case' && !!cur.c) || (name === 'strap' && !!cur.s));
      });
      this.renderBar();
    }
    renderBar() {
      var bar = this.els.bar; if (!bar) return;
      var cur = this.current(), any = cur.c || cur.s;
      bar.hidden = !any || this.summaryVisible || !this.inView;
      if (!any) return;
      var f = this.cfg.moneyFormat;
      var parts = (cur.c ? cur.c.price : 0) + (cur.s ? cur.s.price : 0);
      var total = parts - (cur.c && cur.s ? this.cfg.setDiscount : 0) + (this.state.gift && this.cfg.gift ? this.cfg.gift.price : 0);
      var layered = cur.c && cur.s && cur.c.hasLayer && cur.s.hasLayer;
      this.setImg(this.els.barImg, cur.c ? (layered ? cur.c.layer : cur.c.thumb) : (cur.s ? cur.s.thumb : ''));
      this.setImg(this.els.barImg2, layered ? cur.s.layer : (cur.c && cur.s ? cur.s.thumb : ''));
      bar.classList.toggle('rwc-mobilebar--layered', !!layered);
      if (this.els.barLabel) this.els.barLabel.textContent = [cur.c ? cur.c.label : null, cur.s ? cur.s.label : null].filter(Boolean).join(' + ');
      if (this.els.barPrice) this.els.barPrice.textContent = money(total, f);
      if (this.els.barAdd) this.els.barAdd.disabled = this.els.addBtn ? this.els.addBtn.disabled : false;
    }

    /* ---------- cart ---------- */
    async addToCart() {
      var cur = this.current(); if (!cur.c && !cur.s) return;
      var t = this.cfg.t, btn = this.els.addBtn;
      var setId = 'rw' + Date.now().toString(36);
      var label = [cur.c ? cur.c.label : null, cur.s ? cur.s.label : null].filter(Boolean).join(' + ');
      var props = {}; props['_rw_set'] = setId; props[t.propertyLabel] = label;
      var items = [];
      if (cur.c) items.push({ id: cur.c.variantId, quantity: 1, properties: props });
      if (cur.s) items.push({ id: cur.s.variantId, quantity: 1, properties: props });
      if (this.state.gift && this.cfg.gift) items.push({ id: this.cfg.gift.variantId, quantity: 1, properties: { _rw_set: setId } });

      btn.disabled = true; btn.classList.add('is-loading'); if (this.els.barAdd) this.els.barAdd.disabled = true; if (this.els.error) this.els.error.hidden = true;
      try {
        var r = await fetch(window.theme && theme.routes ? theme.routes.cartAdd : '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!r.ok) { var err = await r.json().catch(function () { return {}; }); throw new Error(err.description || err.message || 'add failed'); }
        track('added_to_cart', { case: cur.c ? cur.c.handle : null, strap: cur.s ? cur.s.handle : null, giftbag: !!(this.state.gift && this.cfg.gift), value: ((cur.c ? cur.c.price : 0) + (cur.s ? cur.s.price : 0)) / 100 });
        if (window.RWGifts && RWGifts.reconcile) { try { await RWGifts.reconcile(); } catch (e) {} }
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: null } }));
        if (window.theme && theme.settings && theme.settings.cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: btn } }));
        } else {
          location.href = (window.theme && theme.routes) ? theme.routes.cart : '/cart';
        }
        if (this.els.gift) { this.els.gift.checked = false; this.state.gift = false; }
      } catch (e) {
        if (this.els.error) { this.els.error.textContent = t.error; this.els.error.hidden = false; }
      } finally {
        btn.classList.remove('is-loading'); this.renderSummary();
      }
    }
    share() {
      var url = location.href, self = this, btn = this.els.share, orig = btn.textContent;
      var done = function () { btn.textContent = self.cfg.t.copied; setTimeout(function () { btn.textContent = orig; }, 1800); };
      if (navigator.share) { navigator.share({ url: url }).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done); else done();
    }
  }

  if (!customElements.get('regler-configurator')) customElements.define('regler-configurator', RWConfigurator);
})();